import { Injectable, OnInit } from "@angular/core";
import { NetworkService } from "../shared/network.service";
import { MessagingService } from "../serivce/messaging.service";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MainService {
  receivedData: any;
  constructor(private networkService: NetworkService) { }

  getChoirApi(body: any) {
    return this.networkService.get(
      "api/choir/list?" + body,
      null,
      null,
      "bearer"
    );
  }

   getChoirById(body: any) {
    return this.networkService.get(
      "api/choir?" + body,
      null,
      null,
      "bearer"
    );
  }
  private dataSubject = new BehaviorSubject<string>("default data");
  currentData = this.dataSubject.asObservable();

  changeData(newData: string) {
    console.log("New token being pushed:", newData);
    this.dataSubject.next(newData);

    if (newData == null) {
      return;
    }
    let req = {
      deviceToken: newData,
      // isProfileBasic: true,
      // req["isProfileBasic"] = true;
    };
    this.updateUser(req).subscribe((res) => {});
    // updateUser(body: any) {
    //   return this.networkService.put(
    //     "api/user/edit/profile",
    //     body,
    //     null,
    //     "bearer"
    //   );
    // }
  }

  getSavedMailApi(body: any) {
    return this.networkService.get(
      "api/mailChimp/campaigns?" + body,
      null,
      null,
      "bearer"
    );
  }
  getSavedChoirApi(body: any) {
    return this.networkService.get(
      "api/savedChoirs?" + body,
      null,
      null,
      "bearer"
    );
  }
  getBookingList(body: any) {
    return this.networkService.get(
      "api/booking/all?" + body,
      null,
      null,
      "bearer"
    );
  }

  getPayments(body: any) {
    return this.networkService.get(
      "api/booking/details/pendingPayments?" + body,
      null,
      null,
      "bearer"
    );
  }
  removeKids(body: any) {
    return this.networkService.put(
      "api/booking/details/",
      body,
      null,
      "bearer"
    );
  }
  getBookingApi(body: any) {
    return this.networkService.get(
      "api/booking/details?" + body,
      null,
      null,
      "bearer"
    );
  }
  getKidApi(body: any) {
    return this.networkService.get(
      "api/user/kids/list?" + body,
      null,
      null,
      "bearer"
    );
  }
  getKidCalcApi(body: any) {
    return this.networkService.get(
      "api/user/kids/list/v1?" + body,
      null,
      null,
      "bearer"
    );
  }
  getCouponApi() {
    return this.networkService.get("api/coupons", null, null, "bearer");
  }
  getScholarShipHomeApi(body: any) {
    return this.networkService.get("api/scholar/list" + body, null, null, null);
  }
  uploadImage(image: any) {
    const formData = new FormData();
    formData.append("image", image);
    return this.networkService.uploadImages(
      "/api/s3upload/image-upload-sync",
      formData,
      null,
      "bearer"
    );
  }
  getQuestions(body: any) {
    return this.networkService.get("api/question" + body, null, null, "bearer");
  }
  submitQuestions(body: any) {
    return this.networkService.post("api/question", body, null, "bearer");
  }
  couponApply(body: any) {
    return this.networkService.post(
      "api/coupons/apply-coupon",
      body,
      null,
      "bearer"
    );
  }
  changePassword(body: any) {
    return this.networkService.post(
      "/api/user/change/password",
      body,
      null,
      "bearer"
    );
  }

  uploadImages(image: any) {
    const formData = new FormData();
    formData.append("file", image);
    return this.networkService.uploadImages(
      "/api/s3upload/media-upload",
      formData,
      null,
      "bearer"
    );
  }
  removeCoupon(body: any) {
    return this.networkService.post("api/coupons/remove", body, null, "bearer");
  }
  addChild(body: any) {
    return this.networkService.post("api/user/add/kid", body, null, "bearer");
  }
  saveChoir(body: any) {
    return this.networkService.post(
      "api/savedChoirs/create",
      body,
      null,
      "bearer"
    );
  }
  stripeBooking(body: any) {
    return this.networkService.post(
      "api/booking/create?success_url=https://web.adventchildrenschoir.org//main/home&cancel_url=https://web.adventchildrenschoir.org//main/home",
      body,
      null,
      "bearer"
    );
  }

  createStripe(body: any) {
    return this.networkService.get(
      "/api/booking/recurring/payment?" + body,
      null,
      null
    );
  }

  addBooking(body: any) {
    return this.networkService.post(
      "api/booking/details/add",
      body,
      null,
      "bearer"
    );
  }
  getUserDetails() {
    return this.networkService.get(
      "api/user/view/profile",
      null,
      null,
      "bearer"
    );
  }
  getNoti() {
    return this.networkService.get(
      "api/notification/list",
      null,
      null,
      "bearer"
    );
  }

  getUnreadNotificationCount() {
    return this.networkService.get(
      "api/notification/unreadCount",
      null,
      null,
      "bearer"
    );
  }

   markAllAsRead() {
    return this.networkService.post(
      "api/notification/readAll",
      null,
      null,
      "bearer"
    );
  }

  getSchoolDataApi(body) {
    return this.networkService.get("/api/school" + body, null, null, "bearer");
  }
  getEducationDataApi(body) {
    return this.networkService.get(
      "/api/edulevel" + body,
      null,
      null,
      "bearer"
    );
  }
  getIncomeDataApi(body) {
    return this.networkService.get("/api/income" + body, null, null, "bearer");
  }
  getActivityApi(body: any) {
    return this.networkService.get("api/etc/activity", body, null, null);
  }
  updateUser(body: any) {
    // debugger;
    return this.networkService.put(
      "api/user/edit/profile",
      body,
      null,
      "bearer"
    );
  }

  getSavedCards() {
    return this.networkService.get("/api/card", null, null, "bearer");
  }

  addCNewCards(body: any) {
    return this.networkService.post("api/card", body, null, "bearer");
  }

  updateAutoPayStatus(body: any) {
    return this.networkService.post(
      "api/card/setDefault",
      body,
      null,
      "bearer"
    );
  }

  deleteCard(cardId: string) {
    return this.networkService.delete(
      `api/card/${cardId}`,
      null,
      null,
      "bearer"
    );
  }
}
